module.exports = cfp.vendors.Redux;